<!-- Scenario Generation Section -->
<div class="row mb-3 mt-3">
  <div class="col text-center">
    <!-- NEW: Toggle for CoT
    <div class="form-check form-switch d-inline-block mb-3 me-3">
      <input class="form-check-input" type="checkbox" id="useCoTAnalysis" [(ngModel)]="useStrategyAnalysis">
      <label class="form-check-label" for="useCoTAnalysis" style="cursor: pointer;">
        Enable Deep Strategy Analysis (AI Chain-of-Thought)
      </label>
    </div> -->

    <br>

    <button class="btn btn-outline-dark" *ngIf="requirementsAnalysis" (click)="generateMacroScenarios()"
      [disabled]="isLoadingMacroGeneration || !requirementsAnalysis">
      <span class="spinner-border spinner-border-sm mr-2" *ngIf="isLoadingMacroGeneration" role="status"
        aria-hidden="true"></span>
      <i class="ft-file-text mr-2" *ngIf="!isLoadingMacroGeneration"></i>
      <span *ngIf="useStrategyAnalysis">Analyze & Generate</span>
      <span *ngIf="!useStrategyAnalysis">Generate Macros (Standard)</span>
    </button>
  </div>
</div>

<div class="row mb-2" *ngIf="isLoadingMacroGeneration">
  <div class="col text-center">
    <div class="small text-muted d-flex align-items-center justify-content-center gap-2">
      <span class="spinner-grow spinner-grow-sm" role="status"></span>
      <span *ngIf="!strategyAnalysisText && useStrategyAnalysis">Phase 1/2: Analyzing Domain Logic & Strategy...</span>
      <span *ngIf="strategyAnalysisText || !useStrategyAnalysis">Phase {{ useStrategyAnalysis ? '2/2' : '1/1' }}:
        Constructing Macro Scenarios...</span>
    </div>
  </div>
</div>

<!-- Global Controls for Scenarios -->
<div class="macro-scenarios-global-controls mb-1" *ngIf="macroScenariosUI.length > 0">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
    <h2 class="mb-0 h5">Workflow Explorer
      <span class="micro-spec-kpi ms-2">({{ macroScenariosUI.length }} Macros)</span>
    </h2>
    <div class="d-flex gap-2 align-items-center flex-wrap">
      <button class="btn btn-sm btn-outline-secondary d-flex align-items-center ml-1"
        (click)="generateMicroSpecsForAll()" [disabled]="isLoadingAllMicroSpecs || isLoadingMacroGeneration"
        title="Generate technical details for all scenarios shown">
        <span *ngIf="isLoadingAllMicroSpecs" class="spinner-border spinner-border-sm me-1" role="status"
          aria-hidden="true"></span>
        <i *ngIf="!isLoadingAllMicroSpecs" class="ft-settings me-1"></i>
        <span class="d-none d-md-inline ml-1">Gen All Micro Scenarios</span>
        <span class="d-md-none">Gen All</span>
      </button>

      <button class="btn btn-outline-info btn-sm ml-1" (click)="checkForCoverageAndFixGaps()"
        [disabled]="isLoadingMacroGeneration || isLoadingAllMicroSpecs || isFixingCoverageGaps"
        title="Check for any requirements not covered by existing scenarios and generate new ones to fill the gaps.">
        <i class="fas fa-check-double" *ngIf="!isFixingCoverageGaps"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
          *ngIf="isFixingCoverageGaps"></span>
        Check & Fix Coverage
      </button>

      <button class="btn btn-sm btn-outline-info d-flex align-items-center ml-1" *ngIf="strategyAnalysisText"
        (click)="toggleStrategyAnalysis()" [class.active]="showStrategyAnalysis"
        title="Toggle display of the strategic analysis that guided this session">
        <i class="ft-search me-1"></i>
        <span class="d-none d-md-inline ml-1">{{ showStrategyAnalysis ? 'Hide Strategy' : 'View Strategy' }}</span>
        <span class="d-md-none">Strategy</span>
      </button>

      <button class="btn btn-sm btn-outline-primary d-flex align-items-center ml-1" (click)="exportMacroAndMicroData()"
        [disabled]="isLoadingMacroGeneration || macroScenariosUI.length === 0"
        title="Export all macro and micro scenario data to a JSON file">
        <i class="ft-download me-1"></i>
        <span class="d-none d-md-inline ml-1">Export Data</span>
        <span class="d-md-none">Export</span>
      </button>

      <button class="btn btn-sm btn-outline-success d-flex align-items-center ml-1"
        (click)="generateAllTestsForAllMacros()"
        [disabled]="isLoadingAllMacroTests || isLoadingMacroGeneration || isLoadingAllMicroSpecs"
        title="Generate all tests for all micro-specifications in all visible scenarios">
        <span *ngIf="isLoadingAllMacroTests" class="spinner-border spinner-border-sm me-1" role="status"
          aria-hidden="true"></span>
        <i *ngIf="!isLoadingAllMacroTests" class="ft-zap me-1"></i>
        <span class="d-none d-md-inline ml-1">Gen All Tests</span>
        <span class="d-md-none">Gen Tests</span>
      </button>

      <button class="btn btn-sm btn-outline-danger d-flex align-items-center ml-1" (click)="clearAllScenarios()"
        [disabled]="isLoadingMacroGeneration || isLoadingAllMicroSpecs || isLoadingAllMacroTests"
        title="Clear all macro scenarios and their associated micro-scenarios and tests">
        <i class="ft-trash-2 me-1"></i>
        <span class="d-none d-md-inline ml-1">Clear All</span>
        <span class="d-md-none">Clear</span>
      </button>
    </div>
  </div>
</div>

<div class="row mb-3 mt-1" *ngIf="showStrategyAnalysis && strategyAnalysisText">
  <div class="col-12 px-3">
    <div class="card shadow-sm border-info bg-light">
      <div class="card-header bg-info text-white py-1 px-3 d-flex justify-content-between align-items-center">
        <span class="small font-weight-bold"><i class="ft-info mr-1"></i> STRATEGIC ANALYSIS (AI Blueprint)</span>
        <button type="button" class="close text-white" style="opacity: 1;" (click)="toggleStrategyAnalysis()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body py-2 px-3">
        <pre class="mb-0 strategy-pre">{{ strategyAnalysisText }}</pre>
      </div>
    </div>
  </div>
</div>

<div class="three-column-workspace" *ngIf="macroScenariosUI.length > 0"
  [class.third-collapsed]="isThirdColumnCollapsed">

  <!-- FIRST COLUMN: Macro Scenarios -->
  <div class="column column-macros" [class.collapsed]="isFirstColumnCollapsed"
    (click)="isFirstColumnCollapsed ? toggleFirstColumn() : null"
    [style.cursor]="isFirstColumnCollapsed ? 'pointer' : 'default'">

    <div class="column-header d-flex justify-content-between align-items-center">
      <h2>{{ isFirstColumnCollapsed ? 'MACRO' : 'MACRO SCENARIOS' }}</h2>

      <button class="btn btn-sm btn-outline-secondary" (click)="toggleFirstColumn(); $event.stopPropagation()"
        [title]="isFirstColumnCollapsed ? 'Expand' : 'Collapse'">
        <i class="fa fa-chevron-left" [class.fa-rotate-180]="isFirstColumnCollapsed"></i>
      </button>
    </div>

    <div class="column-content">
      <div *ngFor="let scenario of macroScenariosUI; let i = index; trackBy: trackByMacroScenarioId"
        class="macro-scenario-item-container">
        <div class="three-col-macro-card"
          [class.active]="selectedMacroScenario && selectedMacroScenario.id === scenario.id"
          (click)="selectMacroScenario(scenario)">
          <h3 class="macro-title d-flex align-items-center">
            <span class="id me-2">{{ scenario.id.split('-').pop() }}</span>

            <!-- NUOVI BADGE PER IL TIPO DI SCENARIO -->
            <span *ngIf="scenario.type === 'E2E_FLOW'" class="badge bg-success me-2 small"
              style="font-size: 0.5em; flex-shrink: 0;">E2E FLOW</span>

            <span *ngIf="scenario.type === 'VALIDATION_GROUP'" class="badge bg-warning text-dark me-2 small"
              style="font-size: 0.5em; flex-shrink: 0;">VALIDATION</span>

            <span *ngIf="scenario.type === 'ALTERNATIVE_FLOW'" class="badge bg-info text-dark me-2 small"
              style="font-size: 0.5em; flex-shrink: 0;">ALT FLOW</span>
            <!-- FINE NUOVI BADGE -->

            <span class="text-truncate" [title]="scenario.scenario_title">{{ scenario.scenario_title }}</span>

            <span *ngIf="getTestCountForMacro(scenario.id) > 0" class="badge bg-primary rounded-pill small ms-auto"
              [title]="getTestCountForMacro(scenario.id) + ' tests'">
              <i class="fa fa-flask me-1"></i>{{ getTestCountForMacro(scenario.id) }}
            </span>
          </h3>
          <div
            *ngIf="selectedMacroScenario && selectedMacroScenario.id === scenario.id && scenario.narrative_description"
            class="macro-summary scenario-narrative-description mb-2">
            <div *ngFor="let part of splitNarrativeDescription(scenario.narrative_description); let isFirst = first">
              <span [class.mt-1]="!isFirst" class="d-block">{{ part }}</span>
            </div>
          </div>
        </div>

        <!-- Details shown only for the selected macro scenario, when not in full edit mode -->
        <div
          *ngIf="selectedMacroScenario && selectedMacroScenario.id === scenario.id && editingScenarioFullId !== selectedMacroScenario.id"
          class="selected-macro-details-in-col1 p-3 mt-1 border-top">
          <div class="mt-2">
            <strong class="section-title d-block mb-1">Gherkin Steps:</strong>
            <div class="gherkin-combined-steps-preview macro-summary p-1 border rounded">
              <div [innerHTML]="getCombinedGherkinStepsHTML(selectedMacroScenario)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SECOND COLUMN: Micro Scenarios -->
  <div class="column column-micros" *ngIf="selectedMacroScenario" [class.collapsed]="isSecondColumnCollapsed"
    (click)="isSecondColumnCollapsed ? toggleSecondColumn() : null"
    [style.cursor]="isSecondColumnCollapsed ? 'pointer' : 'default'">

    <div class="column-header d-flex justify-content-between align-items-center">
      <h2>{{ isSecondColumnCollapsed ? 'MICRO' : selectedMacroScenario.id.split('-').pop() }}</h2>

      <div class="macro-actions-header d-flex gap-1 align-items-center">
        <!-- Only show these buttons when NOT collapsed -->
        <ng-container *ngIf="!isSecondColumnCollapsed">
          <ng-container *ngIf="editingScenarioFullId === selectedMacroScenario.id && scenarioBeingEdited">
            <button class="btn btn-sm btn-success mr-1" (click)="saveFullScenarioEdit()" title="Save Scenario Changes">
              <i class="fa fa-save"></i>
            </button>
            <button class="btn btn-sm btn-secondary mr-1" (click)="cancelFullScenarioEdit()" title="Cancel Edits">
              <i class="fa fa-times"></i>
            </button>
          </ng-container>
          <ng-container *ngIf="editingScenarioFullId !== selectedMacroScenario.id">
            <button class="btn btn-sm btn-outline-primary mr-1"
              (click)="startFullEditMode(selectedMacroScenario, findMacroScenarioIndex(selectedMacroScenario.id))"
              title="Edit Full Scenario (Title, Narrative, Gherkin Steps)">
              <i class="fa fa-edit"></i>
            </button>
          </ng-container>
          <button class="btn btn-sm btn-outline-primary mr-1" (click)="generateMicroSpecsForItem(selectedMacroScenario)"
            [disabled]="getMicroSpecState(selectedMacroScenario.id)?.isGeneratingAny"
            title="Generate/Refresh Micro-Scenarios (Details)">
            <span *ngIf="getMicroSpecState(selectedMacroScenario.id)?.isGeneratingAny"
              class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i *ngIf="!getMicroSpecState(selectedMacroScenario.id)?.isGeneratingAny" class="ft-settings"></i>
          </button>
          <button class="btn btn-sm btn-outline-success mr-1" (click)="generateAllTestsForMacro(selectedMacroScenario)"
            [disabled]="isLoadingTestsForMacroMap.get(selectedMacroScenario.id) || getMicroSpecState(selectedMacroScenario.id)?.isGeneratingAny || isLoadingAllMacroTests || isLoadingAllMicroSpecs"
            title="Generate All Tests for this Macro">
            <span *ngIf="isLoadingTestsForMacroMap.get(selectedMacroScenario.id)"
              class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i *ngIf="!isLoadingTestsForMacroMap.get(selectedMacroScenario.id)" class="ft-zap"></i>
          </button>
          <button class="btn btn-sm btn-outline-danger mr-1"
            (click)="removeScenario(findMacroScenarioIndex(selectedMacroScenario.id))" title="Remove Macro Scenario">
            <i class="ft-trash-2"></i>
          </button>
        </ng-container>

        <!-- Collapse/Expand toggle button (ALWAYS visible) -->
        <button class="btn btn-sm btn-outline-secondary" (click)="toggleSecondColumn(); $event.stopPropagation()"
          [title]="isSecondColumnCollapsed ? 'Expand' : 'Collapse'">
          <i class="fa fa-chevron-left" [class.fa-rotate-180]="isSecondColumnCollapsed"></i>
        </button>
      </div>
    </div>
    <!-- Only show content when NOT collapsed -->
    <div class="column-content" *ngIf="!isSecondColumnCollapsed">
      <!-- Full Edit Mode for Scenario -->
      <div *ngIf="editingScenarioFullId === selectedMacroScenario.id && scenarioBeingEdited" class="p-2">
        <label class="form-label small">Title:</label>
        <input type="text" class="form-control form-control-sm mb-2" [(ngModel)]="scenarioBeingEdited.scenario_title">

        <label class="form-label small">Narrative Description:</label>
        <textarea class="form-control form-control-sm mb-2" [(ngModel)]="scenarioBeingEdited.narrative_description"
          rows="3"></textarea>

        <label class="form-label small">Gherkin Steps:</label>
        <div *ngFor="let sectionKey of ['given', 'when', 'then']" class="gherkin-section mb-2">
          <strong class="text-capitalize gherkin-keyword mr-2 mb-1 d-block">{{ sectionKey }}</strong>
          <ul class="list-unstyled mb-0 gherkin-steps-list">
            <li *ngFor="let step of scenarioBeingEdited.steps[sectionKey]; let stepIndex = index; trackBy: trackByIndex"
              class="gherkin-step-line mb-1 d-flex align-items-center">
              <input type="text" class="form-control form-control-sm flex-grow-1 me-1"
                [(ngModel)]="scenarioBeingEdited.steps[sectionKey][stepIndex]" placeholder="Enter step description">
              <button class="btn btn-sm btn-outline-danger p-1" title="Remove Step"
                (click)="removeGherkinStepFromEdit(sectionKey, stepIndex)">
                <i class="fa fa-trash"></i>
              </button>
            </li>
            <li class="mt-1">
              <button class="btn btn-sm btn-outline-success" (click)="addGherkinStepToEdit(sectionKey)">
                <i class="fa fa-plus"></i> Add {{ sectionKey | titlecase }} Step
              </button>
            </li>
          </ul>
        </div>
        <div class="mt-2 d-flex justify-content-end gap-2 border-top pt-2">
          <button class="btn btn-success btn-sm mr-1" (click)="saveFullScenarioEdit()">Save All Changes</button>
          <button class="btn btn-secondary btn-sm" (click)="cancelFullScenarioEdit()">Cancel All Edits</button>
        </div>
        <hr>
      </div>

      <!-- Normal View Mode -->
      <ng-container *ngIf="editingScenarioFullId !== selectedMacroScenario.id">
        <!-- Micro Scenarios Section -->
        <ng-container *ngIf="getMicroSpecState(selectedMacroScenario.id) as macroState">
          <!-- Title only if there are micro-scenarios or they're being generated -->
          <ng-container
            *ngIf="macroState.isGeneratingAny || (macroState.specifications && macroState.specifications.length > 0) || macroState.error">
            <strong class="section-title">
              Micro-Scenarios:
            </strong>
          </ng-container>

          <!-- Spinner while generating -->
          <div *ngIf="macroState.isGeneratingAny"
            class="d-flex justify-content-center align-items-center p-3 text-muted small">
            <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
            <span>Generating micro-scenarios for this macro...</span>
          </div>

          <ng-container *ngIf="!macroState.isGeneratingAny">
            <!-- Error message if generation failed -->
            <div *ngIf="macroState.error" class="alert alert-warning p-2 small m-2">
              <i class="ft-alert-triangle me-1"></i>
              Error generating micro-scenarios: {{ macroState.error }}
            </div>

            <!-- List of micro-scenarios -->
            <div class="micro-scenario-list-col2 unified-micro-list"
              *ngIf="!macroState.error && macroState.specifications && macroState.specifications.length > 0">

              <div *ngFor="let spec of macroState.specifications; let specIndex = index; trackBy: trackByMicroSpecId"
                class="three-col-micro-card"
                [class.active]="selectedMicroScenario && selectedMicroScenario.id === spec.id && !isConsolidatedViewActive"
                (click)="selectMicroScenario(spec, selectedMacroScenario, spec.gherkin_section)">

                <div class="micro-title d-flex align-items-center">
                  <span class="id me-1">[{{ spec.id.split('-').pop() }}]</span>
                  <span *ngIf="spec.isGeneratingTests" class="spinner-border spinner-border-sm text-primary me-1"
                    role="status" aria-hidden="true"></span>
                  <span class="flex-grow-1">{{ spec.title }}</span>
                </div>
                <div class="micro-meta">

                  <!-- NEW: REUSED BADGE -->
                  <span *ngIf="spec.isReused" class="badge bg-reused me-1"
                    title="This test is reused/shared from Macro ID: {{spec.originMacroId}}">
                    <i class="fa fa-share-alt"></i> Reused
                  </span>
                  <!-- Existing Badges -->
                  <span *ngIf="spec.isDuplicateContent" class="badge bg-info me-1" title="Duplicate">
                    <i class="fa fa-clone"></i>
                  </span>
                  <span *ngIf="spec.tags && spec.tags.length > 0" class="badge bg-secondary me-1">
                    <i class="fa fa-tags"></i> {{spec.tags.length}}
                  </span>
                  <span *ngIf="spec.test_data_elements && spec.test_data_elements.length > 0"
                    class="badge bg-secondary me-1">
                    <i class="fa fa-database"></i> {{spec.test_data_elements.length}}
                  </span>
                  <span *ngIf="getTestCountForMicro(spec.id) > 0" class="badge bg-info ms-auto">
                    <i class="fa fa-flask"></i> {{getTestCountForMicro(spec.id)}}
                  </span>
                </div>
              </div>
            </div>

            <!-- "No micro-scenarios" message -->
            <div *ngIf="!macroState.error && (!macroState.specifications || macroState.specifications.length === 0)"
              class="p-2 text-muted small">
              <p class="mb-0">
                <i class="fa fa-info-circle me-1"></i>
                No micro-scenario details loaded. Click the <i class="ft-settings"></i> (Generate Details) button for
                this macro.
              </p>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Placeholder for when no macro is selected -->
  <div class="column column-micros-placeholder" *ngIf="!selectedMacroScenario && macroScenariosUI.length > 0">
    <div class="placeholder">
      <p>Select a Macro Scenario to view its details and Micro-Scenarios.</p>
    </div>
  </div>

  <!-- THIRD COLUMN: Test Details -->
  <div class="column column-tests" *ngIf="selectedMacroScenario" [class.collapsed]="isThirdColumnCollapsed"
    [class.expanded]="!isThirdColumnCollapsed && (isFirstColumnCollapsed || isSecondColumnCollapsed)"
    (click)="isThirdColumnCollapsed ? toggleThirdColumn() : null"
    [style.cursor]="isThirdColumnCollapsed ? 'pointer' : 'default'">

    <!-- View for Selected Micro-Scenario -->
    <ng-container *ngIf="!isConsolidatedViewActive && selectedMicroScenario">
      <div class="column-header">
        <!-- Content visible only when expanded -->
        <h2 class="d-flex align-items-center justify-content-between" *ngIf="!isThirdColumnCollapsed">
          <span>Micro: {{ selectedMicroScenario?.id.split('-').pop() }}</span>
          <div class="micro-actions-header d-flex gap-1 align-items-center">
            <button class="btn btn-sm btn-outline-primary mr-1" title="Edit specification text"
              (click)="startEditMicroSpecification(selectedMacroScenario.id, selectedMicroScenario.gherkin_section!, selectedMicroScenario); $event.stopPropagation()"
              [disabled]="!selectedMicroScenario">
              <i class="fa fa-pencil"></i>
            </button>
            <button class="btn btn-sm btn-outline-danger mr-1" title="Delete micro-specification"
              (click)="confirmDeleteMicroSpecification(selectedMicroScenario, selectedMacroScenario.id, selectedMicroScenario.gherkin_section!); $event.stopPropagation()"
              [disabled]="!selectedMicroScenario">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </h2>

        <!-- Empty Header for Vertical Text (handled by CSS) when collapsed -->
        <h2 *ngIf="isThirdColumnCollapsed"></h2>

        <!-- Toggle Button -->
        <button class="btn btn-sm btn-outline-secondary ml-2" (click)="toggleThirdColumn(); $event.stopPropagation()"
          [title]="isThirdColumnCollapsed ? 'Expand' : 'Collapse'">
          <i class="fa fa-chevron-right" [class.fa-rotate-180]="isThirdColumnCollapsed"></i>
        </button>
      </div>

      <!-- Content (Hidden via CSS when collapsed, but *ngIf ensures clean DOM) -->
      <div class="column-content" *ngIf="!isThirdColumnCollapsed">
        <div class="micro-spec-details-in-test-column p-2">
          <!-- Edit Mode UI -->
          <div
            *ngIf="editingMicroSpec && editingMicroSpec.specId === selectedMicroScenario?.id && editingMicroSpec.macroId === selectedMacroScenario?.id"
            class="mb-3">
            <label class="form-label small">Title:</label>
            <input type="text" class="form-control form-control-sm mb-2" [(ngModel)]="editingMicroSpec.currentTitle"
              placeholder="Micro scenario title">

            <label class="form-label small">Specification Text:</label>
            <textarea class="form-control form-control-sm flex-grow-1 mb-1" rows="3"
              [(ngModel)]="editingMicroSpec.currentSpecification" placeholder="Micro scenario specification"></textarea>

            <div class="d-flex gap-2 mt-2">
              <button class="btn btn-xs btn-success mr-1" (click)="saveMicroSpecificationEdit()">Save</button>
              <button class="btn btn-xs btn-secondary" (click)="cancelMicroSpecificationEdit()">Cancel</button>
            </div>
            <hr>
          </div>

          <!-- Display Mode UI - Formatted Specification -->
          <div *ngIf="!(editingMicroSpec && editingMicroSpec.specId === selectedMicroScenario?.id) && selectedMicroScenario" class="micro-spec-card mb-3">
            <div class="micro-spec-title mb-2">
              <strong>{{ selectedMicroScenario.title }}</strong>
            </div>

            <ng-container *ngIf="parseSpecificationSections(selectedMicroScenario.specification) as sections">
              <div *ngFor="let section of sections" class="spec-section mb-2">
                <div class="spec-section-label">{{ section.label }}</div>
                <div class="spec-section-content">{{ section.content }}</div>
              </div>
            </ng-container>
          </div>

          <!-- Test Data Section -->
          <div class="mb-3">
            <strong class="section-title-col3">Data Elements:</strong>
            <div class="data-elements-grid">
              <ng-container
                *ngIf="selectedMicroScenario?.test_data_elements && selectedMicroScenario.test_data_elements.length > 0">
                <div *ngFor="let dataElement of selectedMicroScenario.test_data_elements; let k = index"
                     class="data-element-card"
                     (dblclick)="$event.stopPropagation(); openEditTestDataModalForMicroSpec(selectedMicroScenario!, k, dataElement)"
                     [title]="getSmartTooltip(dataElement)">

                  <div class="data-element-field">
                    <i class="fa fa-database text-muted me-1"></i>
                    <strong>{{ getFieldName(dataElement) }}</strong>
                  </div>

                  <div *ngIf="getDataBindingValue(dataElement) as val" class="data-element-value">
                    {{ val }}
                  </div>

                  <button class="data-element-remove"
                          (click)="$event.stopPropagation(); removeTestDataElementForMicroSpec(selectedMicroScenario!, k)"
                          title="Remove">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </ng-container>

              <button class="btn btn-sm btn-outline-primary w-100 mt-2"
                      (click)="$event.stopPropagation(); openAddTestDataModalForMicroSpec(selectedMicroScenario!)"
                      title="Add Test Data" [disabled]="!selectedMicroScenario">
                <i class="fa fa-plus me-1"></i> Add Data Element
              </button>

              <span
                *ngIf="selectedMicroScenario && (!selectedMicroScenario.test_data_elements || selectedMicroScenario.test_data_elements.length === 0)"
                class="text-muted fst-italic small d-block mt-2">(No data elements)</span>
            </div>
          </div>

        <!-- Test Generator Component -->
        <app-micro-scenario-test-generator [macroScenario]="selectedMacroScenario"
          [microScenarioSpec]="selectedMicroScenario" [existingTests]="getMicroScenarioTests(selectedMicroScenario?.id)"
          [refinedStoryContext]="refinedStoryString" (generateTestsRequest)="handleGenerateTestsForSingleMicro()">
        </app-micro-scenario-test-generator>
      </div>
      </div>
    </ng-container>

    <!-- Placeholder when a macro is selected, but no micro-scenario and not consolidated view -->
    <div class="column column-tests-placeholder" *ngIf="!isConsolidatedViewActive && !selectedMicroScenario">

      <!-- NEW Header for placeholder state to allow collapsing -->
      <div class="column-header d-flex justify-content-between align-items-center w-100"
        style="position: absolute; top: 0; left: 0;">
        <h2 *ngIf="isThirdColumnCollapsed"></h2>
        <h2 *ngIf="!isThirdColumnCollapsed" class="text-muted">TEST DETAILS</h2>
        <button class="btn btn-sm btn-outline-secondary" (click)="toggleThirdColumn(); $event.stopPropagation()">
          <i class="fa fa-chevron-right" [class.fa-rotate-180]="isThirdColumnCollapsed"></i>
        </button>
      </div>

      <div class="minimal-placeholder mt-5" *ngIf="!isThirdColumnCollapsed">
        <div class="minimal-icon">
          <i class="fas fa-arrow-left"></i>
        </div>
        <div class="minimal-text">Select a micro-scenario</div>
        <div class="minimal-hint">Choose an item from the middle column to manage its details</div>
      </div>
    </div>
  </div>

  <!-- Placeholder when no macro is selected for third column -->
  <div class="column column-tests-placeholder" *ngIf="!selectedMacroScenario">
    <div class="placeholder">
      <p>Select a Macro Scenario to manage its details and Test Cases.</p>
    </div>
  </div>

</div>

<!-- Test Data Edit Modal Template -->
<ng-template #testDataEditModalMicroSpec let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ editingTestDataMicroSpec.index === -1 ? 'Add' : 'Edit' }} Test Data for Micro-Spec</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form #testDataFormMicroSpec="ngForm">
      <!-- Field Name Section (Add vs Edit) -->
      <div *ngIf="editingTestDataMicroSpec.index === -1">
        <div class="mb-3" *ngIf="availableDataParamFieldsMicroSpec.length > 0">
          <label for="testDataFieldNameSelectMicroSpec" class="form-label">Select Existing Field (Optional)</label>
          <select class="form-select" id="testDataFieldNameSelectMicroSpec" name="testDataFieldNameSelectMicroSpec"
            [(ngModel)]="selectedDataParamFieldMicroSpec" (ngModelChange)="onDataParamFieldSelectedForMicroSpec()">
            <option value="">-- Type custom field name below --</option>
            <option *ngFor="let field of availableDataParamFieldsMicroSpec" [value]="field">{{ field }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="testDataFieldNameInputMicroSpec" class="form-label">Field Name <span
              class="text-danger">*</span></label>
          <input type="text" class="form-control" id="testDataFieldNameInputMicroSpec"
            name="testDataFieldNameInputMicroSpec" [(ngModel)]="editingTestDataMicroSpec.fieldName"
            placeholder="Enter field name"
            [readOnly]="selectedDataParamFieldMicroSpec !== '' && selectedDataParamFieldMicroSpec !== null" required>
          <div
            *ngIf="testDataFormMicroSpec.submitted && testDataFormMicroSpec.controls['testDataFieldNameInputMicroSpec']?.errors?.['required']"
            class="text-danger small mt-1">
            Field name is required.
          </div>
        </div>
      </div>
      <div *ngIf="editingTestDataMicroSpec.index !== -1">
        <div class="mb-3">
          <label for="testDataFieldNameInputEditMicroSpec" class="form-label">Field Name</label>
          <input type="text" class="form-control" id="testDataFieldNameInputEditMicroSpec"
            name="testDataFieldNameInputEditMicroSpec" [(ngModel)]="editingTestDataMicroSpec.fieldName" required
            readonly>
        </div>
      </div>

      <!-- Main Value Input -->
      <div class="mb-3">
        <label for="testDataValidValuesMicroSpec" class="form-label">Value(s) <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="testDataValidValuesMicroSpec" name="testDataValidValuesMicroSpec"
          [(ngModel)]="editingTestDataMicroSpec.validValues" placeholder="e.g., Active, Inactive, 100" required>
        <div
          *ngIf="testDataFormMicroSpec.submitted && testDataFormMicroSpec.controls['testDataValidValuesMicroSpec']?.errors?.['required']"
          class="text-danger small mt-1">
          Value(s) are required.
        </div>
        <small class="form-text text-muted">Comma-separated list of values.</small>
      </div>

      <!-- Contextual Fields -->
      <div class="mb-3">
        <label for="testDataInvalidValuesMicroSpec" class="form-label">Invalid Values (Examples)</label>
        <input type="text" class="form-control" id="testDataInvalidValuesMicroSpec"
          name="testDataInvalidValuesMicroSpec" [(ngModel)]="editingTestDataMicroSpec.invalidValues"
          placeholder="e.g., Pending, -1, XYZ">
        <small class="form-text text-muted">Comma-separated list of example invalid values.</small>
      </div>

      <div class="mb-3">
        <label for="testDataRulesMicroSpec" class="form-label">Rules / Constraints</label>
        <textarea class="form-control" id="testDataRulesMicroSpec" name="testDataRulesMicroSpec" rows="2"
          [(ngModel)]="editingTestDataMicroSpec.rules" placeholder="e.g., Must be a positive integer"></textarea>
        <small class="form-text text-muted">Business rules or constraints for this data field.</small>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
    <button type="submit" class="btn btn-primary"
      (click)="testDataFormMicroSpec.onSubmit($event); saveTestDataChangesForMicroSpec(modal)"
      [disabled]="!testDataFormMicroSpec.form.valid || !editingTestDataMicroSpec.fieldName?.trim() || !editingTestDataMicroSpec.validValues?.trim()">
      Save
    </button>
  </div>
</ng-template>
